import { defaultPeriodDateFrom, defaultPeriodDateTo, formatLocalDateInput } from "../../../lib/api/b2bDates";

export function formatDateInputValue(date: Date) {
    return formatLocalDateInput(date);
}

export function defaultOrdersPeriod() {
    return {
        dateFrom: defaultPeriodDateFrom(),
        dateTo: defaultPeriodDateTo(),
    };
}

export function parseOrderCreatedAt(value: string) {
    const trimmed = value.trim();

    if (trimmed === "") {
        return null;
    }

    const iso = Date.parse(trimmed);

    if (!Number.isNaN(iso)) {
        return new Date(iso);
    }

    const bgMatch = trimmed.match(/^(\d{2})\.(\d{2})\.(\d{4})/);

    if (bgMatch) {
        const [, day, month, year] = bgMatch;

        return new Date(Number(year), Number(month) - 1, Number(day));
    }

    return null;
}
